import React from 'react';
import classnames from 'classnames';
import 'src/components/Pagination/Pagination.scss';
import { Link } from 'react-router';

// isSearch and createUrl specifically used for search page and algolia
type Props = {
    totalPages: number;
    currentPage: number;
    createURL(any);
    refine?(val: number);
};

export const Items: React.FC<Props> = (props) => {
    const { totalPages, currentPage, createURL, refine } = props;
    const pageItems = [...new Array(totalPages)].map((_, i) => i + 1);
    return sliceArray(pageItems, currentPage, totalPages).map((num) => {
        const isCurrent = num === currentPage;
        return (
            <li
                key={num}
                className={classnames({
                    ['ais-Pagination-item']: true,
                    ['ais-Pagination-item--selected']: isCurrent,
                })}
            >
                {isCurrent && (
                    <span className={['ais-Pagination-link', 'ais-Pagination-link--selected'].join(' ')}>{num}</span>
                )}
                {!isCurrent && (
                    <Link
                        className="ais-Pagination-link"
                        to={createURL(num)}
                        onClick={(event) => {
                            if (!refine) return;
                            event.preventDefault();
                            refine(num);
                        }}
                    >
                        {num}
                    </Link>
                )}
            </li>
        );
    });
};

export function sliceArray(array, current, max) {
    if (current < 3) {
        return array.slice(0, 5);
    }
    if (current >= max - 2) {
        return array.slice(-5, max);
    }
    if (current >= 3) {
        return array.slice(current - 3, current + 2);
    }
}
